// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n\n/** 存放自定义的变量，可全局直接使用 */\n\n/** 主题色 */\n\n/** 字体样式 */\n\n/** 边框样式 */\n\n/** 错误样式 */\n\n/** 警告样式 */\n\n/** 可复用的模块化样式 */\n\n/**\n * 设置多行文本超出隐藏\n * $n 为规定多少行\n*/\n.goodsWrap[data-v-8f1e8596] {\n  padding: 0.052083rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.totalWrap[data-v-8f1e8596] {\n  font-weight: 500;\n  font-size: 0.09375rem;\n  margin-bottom: 0.104167rem;\n}", ""]);
// Exports
module.exports = exports;
